import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private toastr: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let cloneRequest = request;

    let user: any = localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
    }

    if (user?.token) {
      cloneRequest = request.clone({
        headers: request.headers
          .set('authorization', `Bearer ${user.token}`)
          .set('Accept-Language', 'es'),
      });
    }

    if (request.url.indexOf('/auth') != -1) {
      cloneRequest = request.clone({
        headers: request.headers.set('authorization', `Bearer login`).set('Accept-Language', 'es'),
      });
    }

    if (
      request.url.indexOf('/external/traceability') != -1 ||
      request.url.indexOf('/external/claim/type') != -1 ||
      request.url.indexOf('/external/tariff') != -1 ||
      request.url.indexOf('/external/contact') != -1
    ) {
      cloneRequest = request.clone({
        headers: request.headers
          .set('authorization', `Bearer IiwiY2xpZW50sInR5cCI6IkpXV`)
          .set('Accept-Language', 'es'),
      });
    }

    return next.handle(cloneRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toastr.error(
            `<span class="now-ui-icons ui-1_bell-53"></span> La sesión del usuario ha expirado y se debe volver a iniciar sesión.</b>`,
            '',
            {
              timeOut: 5000,
              closeButton: true,
              enableHtml: true,
              toastClass: 'alert alert-danger alert-with-icon',
              positionClass: 'toast-top-right',
            }
          );
          this.router.navigate(['auth/login']);
        }
        return throwError(() => error);
      }),
    );
  }
}
